const property_US_Locale = {
    'property.leftContent': 'Shenzhen RayShape Medical Technology Co., Ltd',
    'property.conterContent': '* All data on this website is sourced from usage surveys and related results.',
    'property.rightContent': 'RayShape reserves the final right of interpretation.'
}
export default property_US_Locale
